"use client";

import { useSearchParams, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { m, AnimatePresence } from "framer-motion";

export default function HomeMessage() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const message = searchParams.get("message");
  const [isVisible, setIsVisible] = useState(!!message);
  const [displayMessage, setDisplayMessage] = useState(message);

  useEffect(() => {
    if (!message) return;

    setDisplayMessage(message);
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.delete("message");
      router.replace(`/?${newParams.toString()}`, { scroll: false });
    }, 3000);
    return () => clearTimeout(timer);
  }, [message, router, searchParams]);

  return (
    <AnimatePresence>
      {isVisible && displayMessage && (
        <m.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
          className="bg-foreground border-background/10 relative overflow-hidden border-b"
        >
          {/* Hazard Stripe Pattern */}
          <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,var(--background)_25%,var(--background)_50%,transparent_50%,transparent_75%,var(--background)_75%,var(--background)_100%)] bg-[size:20px_20px] opacity-[0.07]"></div>

          <m.div
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            exit={{ y: -20 }}
            transition={{ duration: 0.5, ease: [0.19, 1, 0.22, 1] }}
            className="text-background relative z-10 px-4 py-3 text-center text-xs font-bold tracking-widest uppercase md:text-sm"
          >
            {decodeURIComponent(displayMessage).replace(/\+/g, " ")}
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
